<template>
  <div class="myTask" @click="outFiltrate">
    <!-- <myTitle til="我的任务"></myTitle> -->
    <main style="height: 100%;" ref="mainNode">
      <header>
        <!-- <input class="searchInput" type="text" v-model="search_mod" placeholder="输入任务名" @change="search" /> -->
        <searchInput placeholder="输入任务名" @search="search" @setSearch="setSearch">
        </searchInput>
        <el-popover placement="bottom" width="200" trigger="manual" v-model="visible">
          <el-form class="filterForm" label-position="right" label-width="70px" :model="formLabelAlign">
            <el-form-item :label="labelName">
              <el-select v-model="formLabelAlign.pm_user_id" @change="changeFiltrate" placeholder="全部">
                <el-option label="全部" value></el-option>
                <el-option v-for="(item, index) in pmUserList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="擅长语言">
              <el-select v-model="formLabelAlign.lang_desc" @change="changeFiltrate" placeholder="全部">
                <el-option label="全部" value></el-option>
                <el-option v-for="(item, index) in langDescList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="擅长领域">
              <el-select v-model="formLabelAlign.domain_code" @change="changeFiltrate" placeholder="全部">
                <el-option label="全部" value></el-option>
                <el-option v-for="(item, index) in domainList" :key="index" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-button class="sortFiltrate" slot="reference" @click.stop="onFiltrate">筛选<i class="el-icon--right"
                                                                                         :class="iconCaret"></i>
          </el-button>
        </el-popover>
        <!-- <i class="search el-icon-search" @click="search"></i> -->
      </header>

      <template>
        <div style="overflow: auto;height:100%">
          <el-table class="tab" ref="refTable"
                    :header-cell-style="{background:'#EAEAEA',color:'#  454545',padding:'6.5px 0'}" :data="tableData"
                    style="width:100%" v-loading="loading" @sort-change="sortChange">
            <template slot="empty">
              <div id="notDate">
                <img src="../../assets/imgs/memory/no_data.png" alt/>
                <p>暂无翻译任务</p>
              </div>
            </template>
            <el-table-column label="序号" min-width="40">
              <template slot-scope="scope">
                <p>
                  {{ scope.$index + 1 }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="taskName" label="任务名称" min-width="80" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <p class="name-active" style=" cursor: pointer" @click="toEditor(scope.row)">
                  {{ scope.row.taskName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column v-if="!standard" prop="myType" label="任务类型" :show-overflow-tooltip="true" min-width="50">
              <template slot-scope="scope">
                {{ myType(scope.row.taskType) }}
              </template>
            </el-table-column>
            <el-table-column prop="projectName" label="所属项目" min-width="50" :show-overflow-tooltip="true">
            </el-table-column>

            <el-table-column prop="pmName" :label="labelName" sortable="custom" :show-overflow-tooltip="true"
                             min-width="60">
            </el-table-column>
            <el-table-column prop="langDesc" label="语言对" sortable="custom" min-width="70" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="sourceWordNum" label="字数" :show-overflow-tooltip="true" min-width="50">
            </el-table-column>
            <el-table-column v-if="$privatization || $independence" prop="progress" label="翻译进度"
                             :show-overflow-tooltip="true" min-width="50">
              <template slot-scope="scope">
                <el-progress :show-text="false" :stroke-width="8" :percentage="scope.row.progress || 0"
                             class="progress">
                </el-progress>
                <p>{{ scope.row.progress || 0 }}%</p>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="操作" min-width="70">
              <template slot-scope="scope">
                <div class="operation">
                  <el-tooltip class="item" effect="dark" :content="contentType(scope.row.taskType)" placement="bottom">
                    <i class="icon-view" style="cursor:pointer;" @click="toEditor(scope.row)"></i>
                  </el-tooltip>
                  <!-- <el-tooltip class="item" effect="dark" content="下载" placement="bottom">
                  <i
                  scope.row.taskType===1 ? '去翻译' : '去审校'
                    class="icon-download"
                    style="cursor:pointer;"
                    @click="getMesBox(scope.$index, scope.row)"
                  ></i>
                </el-tooltip> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" sortable="custom"
                             min-width="70">
              <template slot-scope="scope">
                <p>{{ scope.row.createTime }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="limitTime" label="截止时间" :show-overflow-tooltip="true" sortable="custom"
                             min-width="70" class="classAction">
              <template slot-scope="scope">
                <p :class="datePastCls(scope.row)">{{ scope.row.limitTime }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </main>

    <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
                   :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
                   @current-change="handleCurrentChange">
    </el-pagination>
    <messageBox2 :isShow="mesBox" v-if="mesBox" :tit="mestit" txt :mesShow="mesShow" :imgSrc="imgSrc1" ifForm="0"
                 @message="empty" @messageIf="messageIf"></messageBox2>
    <!--  下载弹窗开始 -->
    <div class="downloadBox" v-show="isShow">
      <h5>
        下载文件
        <span @click="getMesShow">
          <img src="../../assets/imgs/message/popup_close_normal.png" alt/>
        </span>
      </h5>
      <div>
        <span>
          <a :href="
              this.baseURL +
                '/api/v1/file/download_transFile?type=2&fileId=' +
                this.fileId
            " download>
            <i class="translation"></i>
          </a>
          译文
        </span>

        <span>
          <a :href="
              this.baseURL +
                '/api/v1/file/download_transFile?type=3&fileId=' +
                this.fileId
            " download>
            <i class="contrast"></i>
          </a>
          原译对照
        </span>
        <span>
          <a :href="
              this.baseURL +
                '/api/v1/file/download_transFile?type=1&fileId=' +
                this.fileId
            " download>
            <i class="original"></i>
          </a>
          原文
        </span>
      </div>
      <p>*点击图标下载</p>
    </div>
    <div class="hide" v-show="isShow"></div>
    <!--  下载弹窗结束 -->
  </div>
</template>

<script>
import myTitle from "@/common/title.vue";
import messageBox2 from "@/common/messageBox.vue";
import searchInput from "@/common/searchInput.vue";

export default {
  name: "myTask",
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (from.path != "/") {
      // 如果不是刷新则赋值1
      sessionStorage.removeItem("myCurrentPage");
    }
    next();
  },
  data() {
    return {
      tableData: [],
      value1: "",
      value2: "",
      value3: "",
      mesBox: false,
      mesShow: "",
      imgSrc1: require("../../assets/imgs/memory/popup_background.png"), // 弹窗title背景图
      mestit: "", // 弹窗title
      thisRow: "",
      totalRows: 0, // 分页数据总数
      search_mod: "",
      sort: "",
      currentPage: "",
      loading: true,
      isShow: false,
      fileId: "",
      userName: "",
      langDesc: "",
      createTimeL: "",
      limitTime: "",
      visible: false,
      formLabelAlign: {
        lang_desc: "",
        domain_code: "",
        pm_user_id: ""
      },
      domainList: [],
      langDescList: [],
      pmUserList: [],
      iconCaret: "el-icon-caret-bottom",
      tableHeight: window.innerHeight * 0.675, //表格高度是可变的
      standard: true,
      labelName: "项目经理"
    };
  },

  created() {
    if (process.env.VUE_APP_NAME !== "hospital") {
      this.standard = false //true
    } else {
      this.standard = false
    }
    if (process.env.VUE_APP_NAME === "school") {
      this.labelName = "负责人"
    }
    this.currentPage = Number(sessionStorage.getItem("myCurrentPage")) || 1;
    this.getPage(this.currentPage);
    this.getDomainList();
    this.getLangDescList();
    this.getPmUserList();
  },
  components: {
    myTitle,
    messageBox2,
    searchInput
  },
  mounted() {
    // if (this.$refs.mainNode.clientWidth == 0) {
    //   this.$refs.mainNode.style.padding = 0;
    //   this.$alert(
    //     "当前的浏览器不兼容，显示效果可能异常，推荐使用其他模式或Chrome浏览器访问。",
    //     "提示：",
    //     {
    //       confirmButtonText: "确定"
    //     }
    //   );
    // }
  },
  methods: {
    setSearch(data) {
      this.search_mod = data;
    },
    contentType(type) {
      switch (type) {
        case 1:
          return "去翻译"
          break
        case 2:
          return "去审校"
          break
        case 3:
          return "去复审"
          break
      }
    },
    myType(type) {
      switch (type) {
        case 1:
          return "翻译"
          break
        case 2:
          return "审校"
          break
        case 3:
          return "复审"
          break
      }
    },
    // 截止日期过期字体变红
    datePastCls(row) {
      // debugger
      let limitTime = row.limitTime;
      return new Date(limitTime) < new Date() && row.finish === 0
          ? "datePast"
          : null ||
          (new Date(limitTime) < new Date(row.finishTime) && row.finish === 1)
              ? "datePast"
              : null;
    },
    // 获取领域列表
    getDomainList() {
      var that = this;
      this.catReq1Service("/api/v1/fileTask/queryDomainList").then(function (
          response
      ) {
        if (!response.success) {
          return;
        }
        that.domainList = response.result;
      });
    },
    // 获取语言对列表
    getLangDescList() {
      var that = this;
      this.catReq1Service("/api/v1/fileTask/queryLangDescList").then(function (
          response
      ) {
        if (!response.success) {
          return;
        }
        that.langDescList = response.result;
      });
    },
    // 获取项目经理列表
    getPmUserList() {
      var that = this;
      this.catReq1Service("/api/v1/fileTask/queryPmUserList").then(function (
          response
      ) {
        if (!response.success) {
          return;
        }
        that.pmUserList = response.result;
      });
    },
    changeFiltrate() {
      this.currentPage = 1;
      sessionStorage.setItem("myCurrentPage", 1);
      this.getPage(1, this.search_mod, this.sort);
    },
    // 关闭筛选
    outFiltrate() {
      if (this.visible) {
        this.visible = false;
        this.iconCaret = "el-icon-caret-bottom";
        this.currentPage = 1;
        sessionStorage.setItem("myCurrentPage", 1);
        this.getPage(1, this.search_mod, this.sort);
      }
    },
    // 筛选
    onFiltrate() {
      this.visible = !this.visible;
      if (!this.visible) {
        this.iconCaret = "el-icon-caret-bottom";
        this.currentPage = 1;
        sessionStorage.setItem("myCurrentPage", 1);
        this.getPage(1, this.search_mod, this.sort);
      } else {
        this.formLabelAlign = {
          lang_desc: "",
          domain_code: "",
          pm_user_id: ""
        };
        this.iconCaret = "el-icon-caret-top";
      }
    },
    // 跳转编辑query:
    toEditor(row) {
      let path = "/editor";
      if (row.fileUsableSuffix === "xls" || row.fileUsableSuffix === "xlsx") {
        path = "/editorXls";
      } else if (
          row.fileUsableSuffix === "ppt" ||
          row.fileUsableSuffix === "pptx" ||
          row.fileUsableSuffix === "html" ||
          row.fileUsableSuffix === "xlf" ||
          row.fileUsableSuffix === "htm" ||
          row.fileUsableSuffix === "eml") {
        path = "/editorTab";
      }
      if (IS_TABLE) {
        path = "/editorTab";
      }
      // this.$router.push({
      //   path,
      //   query: {
      //     key: this.$Base64.encode(
      //       JSON.stringify({
      //         fileId: row.fileId,
      //         sourceLang: row.sourceLang,
      //         targetLang: row.targetLang,
      //         taskName: row.taskName,
      //         wordNum: row.sourceWordNum,
      //         taskId: row.id,
      //         project: 3,
      //       })
      //     )
      //   }
      // });
      let routeData1 = this.$router.resolve({
        path,
        query: {
          key: this.$Base64.encode(
              JSON.stringify({
                fileId: row.fileId,
                sourceLang: row.sourceLang,
                targetLang: row.targetLang,
                taskName: row.taskName,
                wordNum: row.sourceWordNum,
                taskId: row.id,
                project: 3,
                userId: row.userId,
                taskType: row.taskType || 1,
                transStatus: 1,
                fileSuffix: row.fileUsableSuffix,
                transModel: row.transModel
              })
          )
        }
      });
      window.open(routeData1.href, "_blank");
      //window.open(path, "editor")
    },
    // 下载弹窗关闭
    getMesShow() {
      this.isShow = false;
    },
    // 下载弹窗
    getMesBox(index, row) {
      // console.log(row);
      var that = this;
      that.isShow = true;
      that.fileId = row.fileId;
    },
    // 排序
    sortChange({column, prop, order}) {
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      }
      if (prop == "pmName") {
        this.sort = {pm_user_id: order};
        this.getPage(this.currentPage, this.search_mod, {pm_user_id: order});
      } else if (prop == "createTime") {
        this.sort = {create_time: order};
        this.getPage(this.currentPage, this.search_mod, {create_time: order});
      } else if (prop == "limitTime") {
        this.sort = {limit_time: order};
        this.getPage(this.currentPage, this.search_mod, {limit_time: order});
      } else {
        this.sort = {lang_desc: order};
        this.getPage(this.currentPage, this.search_mod, {lang_desc: order});
      }
    },
    // 搜索
    search() {
      this.search_mod = this.search_mod.replace(
          /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
          ""
      );
      this.getPage("1", this.search_mod);
    },
    // 跳转页
    handleCurrentChange(val) {
      this.getPage(val, this.search_mod, this.sort);
      sessionStorage.setItem("myCurrentPage", val); // 将页码存sessionStorage，刷新还在当前页
    },
    // 分页获取数据
    getPage(page, search, sort) {
      var that = this;
      let obj = that.formLabelAlign || {};
      obj.task_name = search;
      for (let propName in obj) {
        if (obj[propName] === "") {
          delete obj[propName];
        }
      }
      obj.platformType = this.$platformType; // 平台编码
      obj.company_code = localStorage.myCompanyCode; // 公司编码
      let params = {
        page: page,
        rows: 20,
        filter: obj,
        sort: sort || {create_time: "desc"}
      };
      this.catReq1Service("/api/v1/fileTask/query_page/my_task", params).then(
          function (response) {
            if (!response.success) {
              return;
            }
            if (response.list == null) {
              response.list = [];
            }
            that.tableData = response.list;
            that.totalRows = response.totalRows;
            that.loading = false;
            if (that.currentPage > 1 && that.tableData.length < 1) {
              sessionStorage.myCurrentPage = sessionStorage.myCurrentPage - 1;
              that.currentPage - 1;
              that.getPage(
                  sessionStorage.myCurrentPage,
                  that.search_mod,
                  that.sort
              );
            }
            that.tableData.forEach(item => {
              item.createTime = that.dateReg(item.createTime);
              // item.limitTime = that.dateReg(item.limitTime);
              item.myType = item.taskType === 2 ? "审校" : "翻译"
            });
          }
      );
      // .catch(function(error) {
      //   that.$message({
      //     message: "网络出错!",
      //     type: "warning"
      //   });
      // });
    },

    // empty (data) {
    //   console.log(data, "this.expands???");
    //   // console.log(this.thisRow, "this.expands???");
    //   this.mesBox = false;
    //   data.forEach(item => {
    //     item.date = this.thisRow.date;
    //   });
    //   this.thisRow.tableData2.push(...data);
    // },
    messageIf(row) {
      // alert("111")
      var that = this;
      // console.log(row);
      that.mesShow = "3";
      that.thisRow = row;
      that.mestit = "上传文件";
      // that.mestit = str;
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.myTask {
  //   padding: 30px;
  position: relative;
  // min-height: 617px;
  main {
    background: #f5f4f4;
    border-radius: 6px;
    // margin-top: git20px;
    padding: 20px;
    // padding-bottom:60px;
    padding-top: 10px;
    position: relative;
    // .searchInput {
    //   float: right;
    //   width: 222px;
    //   height: 34px;
    //   line-height: 36px;
    //   border: 1px solid rgba(184, 196, 206, 1);
    //   border-radius: 2px;
    //   padding: 0 10px;
    //   margin-right: 20px;
    //   background: #f5f4f4;
    //   padding-right: 26px;
    // }
    // .searchInput:focus {
    //   outline: none;
    //   border: 1px solid #454545;
    // }
    // .search {
    //   position: absolute;
    //   right: 30px;
    //   top: 10px;
    //   cursor: pointer;
    // }
    header {
      height: 38px;
      position: relative;
      margin-bottom: 10px;

      span {
        float: right;
        margin-right: 20px;
        // margin-top: 20px;
        // margin-top: 10px;
        .sortFiltrate {
          background: #f5f4f4;
          float: right;
          width: 100px;
          height: 36px;
          border: 0px;
          line-height: 0px;
          color: black;
        }
      }
    }
  }

  .tofile {
    width: 81px;
    height: 26px;
    line-height: 26px;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    background: red;
    color: #ffff;
  }

  /deep/ .el-progress-bar__innerText {
    line-height: 15px;
  }

  .el-table__expand-icon {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  /deep/ .el-progress-bar__outer {
    // 进度条颜色
    //background: white !important;
    border: 1px solid #0e54b4 !important;
  }

  // /deep/.el-progress-bar__inner {
  //   background: rgba(102, 102, 102, 1) !important;
  // }
  // 表格样式开始
  /deep/ .el-table td {
    border-bottom: 1px solid #e7e7e7 !important;
  }

  .el-table {
    // margin: 10px auto;
    background: #f5f4f4;
    height: calc(100% - 80px);
    color: #333333;
    margin: 0 auto;

    /deep/ table {
      .has-gutter {
        th {
          .cell {
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    /deep/ .row-expand-cover .el-table__expand-icon {
      visibility: hidden;
    }

    /deep/ th {
      text-align: center;
    }

    /deep/ .el-table__expanded-cell {
      padding: 0;
      padding-left: 20px;
      border-bottom: 0px;
    }

    /deep/ .el-table__expanded-cell:hover {
      background: #fff !important;
    }
  }

  /deep/ .el-table::before {
    height: 0px;
  }

  /deep/ .el-table--enable-row-hover .el-table__body tr {
    background: #f5f4f4;
  }

  /deep/ .el-table tr th:nth-child(2),
  /deep/ .el-table tr th:nth-child(3) {
    text-align: center;
  }

  /deep/ .el-table_1_column_3 {
    .el-tooltip {
      text-align: center;
    }
  }

  /deep/ .el-table td,
  .el-table th {
    // 修改table行高
    padding: 7px 2px !important;
    //   height: 36px !important;
    font-size: 12px;

    .cell {
      .datePast {
        color: red;
      }
    }
  }

  /deep/ .el-table td {
    text-align: center;
    height: 24px;

    .operation {
      display: none;

      i {
        display: inline-block;
        margin: 0 10px;
        width: 20px;
        height: 20px;
      }

      .icon-view {
        background: url("../../assets/imgs/project/edit_normal.png") no-repeat;
      }

      .icon-view:hover {
        background: url("../../assets/imgs/project/edit_hover.png") no-repeat;
      }

      .icon-view:active {
        background: url("../../assets/imgs/project/edit_press.png") no-repeat;
      }

      .icon-download {
        background: url("../../assets/imgs/project/download_normal.png") no-repeat;
      }

      .icon-download:hover {
        background: url("../../assets/imgs/project/download_hover.png") no-repeat;
      }

      .icon-download:active {
        background: url("../../assets/imgs/project/download_press.png") no-repeat;
      }
    }
  }

  /deep/ .el-table td:nth-child(2),
  /deep/ .el-table td:nth-child(3) {
    text-align: center;

    .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  /deep/ .el-table th.is-leaf {
    border-bottom: 0px;
  }

  //   /deep/.el-table .el-table .el-table  td:nth-child(2) {
  //     text-align: center;
  //   }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover {
    // box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    .operation {
      display: block;
    }
  }

  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: rgba(210, 210, 210, 1);
  }

  /deep/ .el-table {
    .el-table__empty-block {
      // 修改无数据 出现滚动条
      height: 90% !important;
    }
  }

  // 表格样式结束
  /* 页码样式开始 */

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    // 页码点击效果
    // background: rgba(69, 69, 69, 1);
    color: rgba(255, 255, 255, 1);
    border: 0px;
  }

  /deep/ .el-pager li {
    // 页码样式
    min-width: 30px;
    height: 30px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 2px;
    background: transparent;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
  }

  /deep/ .el-pagination button {
    // 页码上下页样式
    width: 68px;
    height: 30px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 2px;
    line-height: 30px;
    font-size: 14px;
    background: transparent;
    color: rgba(102, 102, 102, 1);
    font-weight: 400;
  }

  /deep/ .el-pagination button:hover {
    border: 1px solid rgba(128, 128, 128, 1);
  }

  /deep/ .el-pagination button:active {
    background: rgba(224, 237, 252, 1);
    border: 1px solid rgba(187, 187, 187, 1);
  }

  .page {
    // margin-top: 30px;
    // float: right;
    position: absolute;
    bottom: -20px;
    right: 20px;
  }

  /* 页码样式结束 */
  // 下载弹窗
  .hide {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    z-index: 888;
  }

  .downloadBox {
    width: 450px;
    height: 290px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    opacity: 1;

    h5 {
      width: 450px;
      height: 48px;
      line-height: 48px;
      background: rgba(177, 178, 178, 1);
      border-radius: 10px 10px 0px 0px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      position: relative;

      span {
        position: absolute;
        right: 10px;

        img {
          cursor: pointer;
          -webkit-transition: -webkit-transform 0.6s ease-out;
          -moz-transition: -moz-transform 0.6s ease-out;
          transition: transform 0.6s ease-out;
        }

        img:hover {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }
    }

    div {
      margin: 70px 0px auto;
      display: flex;
      justify-content: center;

      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
        width: 100px;
      }

      i {
        width: 32px;
        height: 32px;
        // vertical-align: middle;
        display: block;
        cursor: pointer;
        margin: 0 auto;
        text-align: center;
      }

      .translation {
        background: url("../../assets/imgs/project/translation_normal.png") no-repeat;
      }

      .contrast {
        background: url("../../assets/imgs/project/contrast_normal.png") no-repeat;
      }

      .original {
        background: url("../../assets/imgs/project/original_text_normal.png") no-repeat;
      }

      // .full {
      //   background: url("../../assets/imgs/project/full_text_normal.png") no-repeat;
      // }
      .translation:hover {
        background: url("../../assets/imgs/project/translation_hover.png") no-repeat;
      }

      .contrast:hover {
        background: url("../../assets/imgs/project/contrast_hover.png") no-repeat;
      }

      // .full:hover {
      //   background: url("../../assets/imgs/project/full_text_hover.png") no-repeat;
      // }
    }

    p {
      position: absolute;
      bottom: 29px;
      left: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }

  // 下载弹窗 结束
}

/deep/ .el-select .el-input {
  width: 100%;
}

.filterForm {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
<style lang="less">
.myTask {
  main {
    // .tab {
    //   .el-table__body {
    //     // border-collapse: separate !important;
    //     // border-spacing: 0px 8px !important;
    //   }
    // }
  }

  .name-active:hover {
    text-decoration: underline;
  }
}
</style>
<style lang="less">
.myTask {
  height: calc(100% - 40px);

  .el-table__body-wrapper {
    overflow-y: auto;
    height: calc(100% - 70px);
  }
}
</style>
